(function () {
  'use strict';

  function initTransparentHeader() {
    var header = document.querySelector('.header-wrapper--transparent-home');
    if (!header) return;

    var target = document.querySelector('#MainContent > .shopify-section:first-child');

    function threshold() {
      if (!target) return window.innerHeight * 0.85;
      return Math.max(target.offsetHeight - (header.offsetHeight || 80), 120);
    }

    function update() {
      if (window.scrollY > threshold()) {
        header.classList.add('header-wrapper--solid');
      } else {
        header.classList.remove('header-wrapper--solid');
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initHeroVideo(hero) {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var wrappers = hero.querySelectorAll('.coature-hero__video');
    if (!wrappers.length || reducedMotion) return;

    function activeWrapper() {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var selector = isMobile ? '.coature-hero__video--mobile' : '.coature-hero__video--desktop';
      return hero.querySelector(selector) || wrappers[0];
    }

    var current = activeWrapper();
    var userPaused = false;

    function play(wrapper) {
      var video = wrapper && wrapper.querySelector('video');
      if (!video) return;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise
          .then(function () {
            wrapper.classList.add('is-playing');
            hero.setAttribute('data-video-ready', 'true');
          })
          .catch(function () {
            /* Autoplay blocked — poster image remains visible. */
          });
      }
    }

    function pause(wrapper) {
      var video = wrapper && wrapper.querySelector('video');
      if (video) video.pause();
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!userPaused) play(current);
          } else {
            pause(current);
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(hero);

    window.addEventListener(
      'resize',
      function () {
        var next = activeWrapper();
        if (next !== current) {
          pause(current);
          current.classList.remove('is-playing');
          current = next;
          if (!userPaused) play(current);
        }
      },
      { passive: true }
    );

    var toggle = hero.querySelector('[data-coature-video-toggle]');
    if (toggle) {
      var iconPause = toggle.querySelector('[data-icon-pause]');
      var iconPlay = toggle.querySelector('[data-icon-play]');
      var labelPause = toggle.querySelector('[data-label-pause]');
      var labelPlay = toggle.querySelector('[data-label-play]');

      toggle.addEventListener('click', function () {
        userPaused = !userPaused;
        if (userPaused) {
          pause(current);
        } else {
          play(current);
        }
        toggle.setAttribute('aria-pressed', String(userPaused));
        if (iconPause) iconPause.hidden = userPaused;
        if (iconPlay) iconPlay.hidden = !userPaused;
        if (labelPause) labelPause.hidden = userPaused;
        if (labelPlay) labelPlay.hidden = !userPaused;
      });
    }
  }

  function init() {
    initTransparentHeader();
    document.querySelectorAll('.coature-hero').forEach(initHeroVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
